module.exports = __webpack_public_path__ + "img/icon-link.0716fd60.png";